import { render, staticRenderFns } from "./StatusSetPanel.vue?vue&type=template&id=51a8148c&scoped=true"
import script from "./StatusSetPanel.vue?vue&type=script&lang=ts"
export * from "./StatusSetPanel.vue?vue&type=script&lang=ts"
import style0 from "./StatusSetPanel.vue?vue&type=style&index=0&id=51a8148c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51a8148c",
  null
  
)

export default component.exports